import { Button, Checkbox } from '@features/ui';
import { UserProfile } from '@src/types/users.ts';
import { FC } from 'react';
import { formatDateByMST } from '@lib/utils.ts';

interface RithmicUserProps {
  user: UserProfile | null;
  onUpdateRithmic?: () => void;
  onResendWelcomeEmail?: () => void;
}
export const RithmicUser: FC<RithmicUserProps> = ({
  user,
  onUpdateRithmic,
  onResendWelcomeEmail,
}) => {
  return (
    <div>
      <div className={'flex gap-2'}>
        <Button size={'sm'} variant={'secondary'} onClick={onUpdateRithmic}>
          Update User Rithmic
        </Button>
        <Button size={'sm'} variant={'lime'} onClick={onResendWelcomeEmail}>
          Resend Welcome Email
        </Button>
      </div>

      <div className={'flex mt-4 text-xs'}>
        <div className={'flex-1'}>
          <div
            className={
              'p-1 rounded-[2px] border w-fit bg-[#cce5ff] text-[#004085] border-[#b8daff]'
            }
          >
            <p>{`Rithmic > Rithmic Paper Trading`}</p>
          </div>
          <p className={'mt-5'}>Expires</p>
          <p className={'mt-1'}>{formatDateByMST(user?.expire_date ?? '')}</p>
        </div>

        <div className={'flex-1'}>
          <p>Market Access / Depth</p>
          <div className={'flex flex-col gap-2 mb-4 my-4'}>
            <div className={'flex items-center'}>
              <div className={'w-23'}>
                <Checkbox
                  checked={true}
                  className="w-[22px] h-[22px] border-2 border-white"
                  disabled={true}
                  id="CME"
                  label={'CME'}
                />
              </div>
              <p className={'ml-6 bg-lime py-[2px] px-1 rounded-[3px]'}>LVL1</p>
            </div>
            <div className={'flex items-center'}>
              <div className={'w-23'}>
                <Checkbox
                  checked={true}
                  className="w-[22px] h-[22px] border-2 border-white"
                  disabled={true}
                  id="CBOT"
                  label={'CBOT'}
                />
              </div>
              <p className={'ml-6 bg-lime py-[2px] px-1 rounded-[3px]'}>LVL1</p>
            </div>
            <div className={'flex items-center'}>
              <div className={'w-23'}>
                <Checkbox
                  checked={true}
                  className="w-[22px] h-[22px] border-2 border-white"
                  disabled={true}
                  id="COMEX"
                  label={'COMEX'}
                />
              </div>
              <p className={'ml-6 bg-lime py-[2px] px-1 rounded-[3px]'}>LVL1</p>
            </div>
            <div className={'flex items-center'}>
              <div className={'w-23'}>
                <Checkbox
                  checked={true}
                  className="w-[22px] h-[22px] border-2 border-white"
                  disabled={true}
                  id="NYMEX"
                  label={'NYMEX'}
                />
              </div>
              <p className={'ml-6 bg-lime py-[2px] px-1 rounded-[3px]'}>LVL1</p>
            </div>
            <div className={'flex items-center'}>
              <div className={'w-23'}>
                <Checkbox
                  checked={false}
                  className="w-[22px] h-[22px] border-2 border-white"
                  disabled={true}
                  id="EUREX"
                  label={'EUREX'}
                />
              </div>
              <p
                className={
                  'ml-6 bg-[#ddd] py-[2px] px-1 text-[#ababab] rounded-[3px]'
                }
              >
                N/A
              </p>
            </div>
            <div className={'flex items-center'}>
              <div className={'w-23'}>
                <Checkbox
                  checked={false}
                  className="w-[22px] h-[22px] border-2 border-white"
                  disabled={true}
                  id="q_stocks"
                  label={'Q (stocks)'}
                />
              </div>
              <p
                className={
                  'ml-6 bg-[#ddd] py-[2px] px-1 text-[#ababab] rounded-[3px]'
                }
              >
                N/A
              </p>
            </div>
          </div>
          <p>Max Session Count for Data: {user?.max_session_data ?? 0}</p>
        </div>
      </div>
    </div>
  );
};
